function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react/no-array-index-key */
import React from 'react';
import Types from 'prop-types';
import classNames from 'classnames';
import Item from './Item';
import { LocaleValues } from '../../../../common/l10n';
var Items = function Items(_ref) {
  var items = _ref.items,
    inverse = _ref.inverse,
    language = _ref.language,
    availableLanguages = _ref.availableLanguages,
    onLanguageChange = _ref.onLanguageChange,
    activePath = _ref.activePath,
    isSubMenu = _ref.isSubMenu,
    className = _ref.className,
    onCloseMenu = _ref.onCloseMenu,
    isPillNavigation = _ref.isPillNavigation,
    locale = _ref.locale,
    availableLocales = _ref.availableLocales,
    onLocaleChange = _ref.onLocaleChange,
    withCountrySelector = _ref.withCountrySelector;
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames('tw-public-nav__list', {
      'tw-public-nav__submenu': isSubMenu
    }, className)
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Item, _extends({}, item, {
      key: index,
      inverse: inverse,
      language: language,
      availableLanguages: availableLanguages,
      onLanguageChange: onLanguageChange,
      activePath: activePath,
      isInSubMenu: isSubMenu,
      onCloseMenu: onCloseMenu,
      isPillNavigation: isPillNavigation,
      locale: locale,
      availableLocales: availableLocales,
      onLocaleChange: onLocaleChange,
      withCountrySelector: withCountrySelector
    }));
  }));
};
Items.defaultProps = {
  inverse: false,
  activePath: undefined,
  isSubMenu: false,
  onCloseMenu: function onCloseMenu() {},
  className: '',
  availableLanguages: null,
  availableLocales: null,
  onLanguageChange: function onLanguageChange() {},
  onLocaleChange: function onLocaleChange() {},
  locale: '',
  withCountrySelector: false
};
export default Items;